import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/insidePages';
import { OFFER_ANCHOR } from '../data/constants';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(index, insidePages.length - 1));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setActive(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const next = Math.round(track.scrollLeft / track.clientWidth);
      setActive(Math.max(0, Math.min(next, insidePages.length - 1)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const arrowClass = 'absolute top-1/2 z-10 -translate-y-1/2 rounded-full bg-diag p-2 text-white shadow-lg transition-[background-color,opacity] duration-150 ease-out hover:bg-diaghover disabled:pointer-events-none disabled:opacity-0 sm:p-3';
  return <section className="bg-navy py-6 sm:py-9" data-id="element-83" data-mp="f20pr6z5h0hc">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-84" data-mp="f2ahp03r9hpo">
        <h2 className="text-center text-[25px] leading-none text-white sm:text-[40px]" data-id="element-85" data-mp="3nh18398l8urv">
          Look <span className="text-diag" data-id="element-86" data-mp="3iirdazqrzw6s">inside</span>
        </h2>
        <p className="mt-2 text-center font-display text-[15px] font-semibold uppercase leading-tight text-white sm:text-[20px]" data-id="element-87" data-mp="3igelluv7u7gj">
          Discover What's Inside GASOLINE ENGINE DIAGNOSTIC PRO™
        </p>
        <p className="mx-auto mt-2 max-w-[820px] text-center text-[13.5px] font-medium leading-snug text-steellight sm:text-[16px]" data-id="element-88" data-mp="3sekpgi0l1no1">
          No-start diagnostics, fuel injection, ignition systems, misfires, sensors,
          fuel trims, OBD-II data, vacuum leaks, VVT, drivability problems,
          electrical testing and structured fault-finding workflows.
        </p>

        <div className="relative mt-4" data-id="element-89" data-mp="18mdhjxukrkl3">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto overscroll-x-contain" aria-label="Interior pages carousel" data-id="element-90" data-mp="1den5j8c4qakq">
            {insidePages.map((page, i) => <div key={page.src} className="w-full shrink-0 snap-center" role="group" aria-roledescription="slide" aria-label={`Page ${i + 1} of ${insidePages.length}`} data-id="element-91" data-mp="krk6mf3jjxty" data-mpi={i}>
                <a href={OFFER_ANCHOR} className="mx-auto block max-w-[640px] overflow-hidden rounded-md bg-white p-1 shadow-[0_18px_40px_-16px_rgba(0,0,0,0.6)]" data-id="element-92" data-mp="yqa6u3lnqdmj">
                  <img src={page.src} alt={page.alt} loading={i === 0 ? 'eager' : 'lazy'} className="block w-full rounded-sm object-contain" data-id="element-93" data-mp="2a3w5qghbjtl9" />
                </a>
              </div>)}
          </div>

          <button type="button" onClick={() => scrollTo(active - 1)} disabled={active === 0} aria-label="Previous page" className={`${arrowClass} left-1 sm:left-4`} data-id="element-94" data-mp="2ahq6dgqzum6w">
            <ChevronLeftIcon className="h-5 w-5" strokeWidth={3} data-id="element-95" data-mp="21g07jpus8kz3" />
          </button>
          <button type="button" onClick={() => scrollTo(active + 1)} disabled={active === insidePages.length - 1} aria-label="Next page" className={`${arrowClass} right-1 sm:right-4`} data-id="element-96" data-mp="1wlcr8e9xmwvl">
            <ChevronRightIcon className="h-5 w-5" strokeWidth={3} data-id="element-97" data-mp="3lyhj2cpu3hm1" />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-98" data-mp="3hxnxvr3s0gwu">
          {insidePages.map((page, i) => <button key={page.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === active} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out ${i === active ? 'w-7 bg-diag' : 'w-2 bg-navyline hover:bg-steel'}`} data-id="element-99" data-mp="3p147g6rpvach" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}